import { ScreenContext } from '@/contexts/ScreenContext';
import { getVHByRem } from '@/utils/commonFunc';
import Box from '@mui/material/Box';
import { ReactNode, useContext, useEffect, useState } from 'react';
import './RwdSvgIcon.scss';
/**
 * fix box
 */
export type RwdSvgIconProps = {
    defaultWidth?: number; // rem
    defaultHight?: number; // rem
    rwdWidthRule?: string; // calc
    rwdHeightRule?: string; // calc
    vSize?: number; //vSize = defaultWidth = defaultHight
    hSize?: string; //hSize = rwdWidthRule = rwdHeightRule
    children: ReactNode; // set svg width=100% height=100%
};
export const RwdSvgIcon = (props: RwdSvgIconProps) => {
    const {
        defaultWidth = 1.5,
        defaultHight = 1.5,
        rwdWidthRule = getVHByRem(1.5),
        rwdHeightRule = getVHByRem(1.5),
        vSize,
        hSize,
        children,
    } = props;

    const [svgWidth, setSvgWidth] = useState<string | number>(
        `${defaultWidth}rem`
    );
    const [svgHeight, setSvgHeight] = useState<string | number>(
        `${defaultHight}rem`
    );

    const { isLandscape } = useContext(ScreenContext);

    useEffect(() => {
        const iconWidth = isLandscape
            ? (hSize ?? rwdWidthRule)
            : vSize
              ? `${vSize}rem`
              : `${defaultWidth}rem`;
        setSvgWidth(iconWidth);
        const iconHeight = isLandscape
            ? (hSize ?? rwdHeightRule)
            : vSize
              ? `${vSize}rem`
              : `${defaultHight}rem`;
        setSvgHeight(iconHeight);
    }, [isLandscape]);

    return (
        <Box
            width={svgWidth}
            height={svgHeight}
            display={'flex'}
            alignContent={'center'}
            justifyContent={'center'}
            className={'rwd-svg-icon-container'}
        >
            {children}
        </Box>
    );
};
